import { demonstrationDisclosureV1Schema, frozenDemonstrationBasisV1Schema, type DemonstrationDisclosureV1 } from '../../types/demonstration';

/** Read only frozen report metadata. Malformed or conflicting supplied stamps
 * fail closed; a site name or live setting never establishes this disclosure. */
export function reportDemonstrationDisclosure(report: {
  demonstrationProvenance?: unknown; demonstrationSedProvenance?: unknown; demonstrationDisclosure?: unknown;
}): DemonstrationDisclosureV1 | undefined {
  let privateDisclosure: DemonstrationDisclosureV1 | undefined;
  let reportOwner: string | undefined;
  if (report.demonstrationProvenance !== undefined) {
    const basis = frozenDemonstrationBasisV1Schema.parse(report.demonstrationProvenance);
    if (basis.scope !== 'report') throw new Error('Demonstration disclosure requires a frozen report basis.');
    reportOwner = basis.ownerUid;
    privateDisclosure = demonstrationDisclosureV1Schema.parse({
      schemaVersion: basis.schemaVersion, kind: basis.kind, scenarioId: basis.scenarioId, notice: basis.notice,
    });
  }
  if (report.demonstrationSedProvenance !== undefined) {
    const sedBasis = frozenDemonstrationBasisV1Schema.parse(report.demonstrationSedProvenance);
    if (sedBasis.scope !== 'sed' || !privateDisclosure) {
      throw new Error('Frozen demonstration SED metadata requires its own scope and a frozen report basis.');
    }
    if (sedBasis.ownerUid !== reportOwner || sedBasis.scenarioId !== privateDisclosure.scenarioId) {
      throw new Error('Conflicting frozen demonstration SED and report bases.');
    }
  }
  const publicDisclosure = report.demonstrationDisclosure === undefined
    ? undefined : demonstrationDisclosureV1Schema.parse(report.demonstrationDisclosure);
  if (privateDisclosure && publicDisclosure && privateDisclosure.scenarioId !== publicDisclosure.scenarioId) {
    throw new Error('Conflicting frozen demonstration disclosures.');
  }
  return privateDisclosure ?? publicDisclosure;
}
